// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyViewer_wrapper__-5ryj","mainWrapper":"EmptyViewer_mainWrapper__MFHWR","center":"EmptyViewer_center__pLEwk"};